import { RatingsPage } from "views";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

const ReviewStars = ({ title, rating }) => {
  // Calculate the number of full, half, and empty stars
  const fullStars = Math.floor(rating / 2); // Full stars (out of 5)
  const halfStars = rating % 2 >= 1 ? 1 : 0; // Half star
  const emptyStars = 5 - fullStars - halfStars; // Empty stars
  const { t } = useTranslation("global");

  // Create an array of star elements
  const stars = [
    ...Array(fullStars).fill("full"),
    ...Array(halfStars).fill("half"),
    ...Array(emptyStars).fill("empty"),
  ];
  if (!!!rating) return null;
  return (
    <div className={styles.reviewContainer}>
      <p className={styles.title}>{title}</p>
      <div className={styles.ratingContainer}>
        <div className={styles.stars}>
          {stars.map((star, index) => (
            <span
              key={index}
              className={`${styles.star} ${styles[star]}`}
            ></span>
          ))}
        </div>
        <div>
          <span className={styles.rating}>{rating}</span>
          <span className={styles.from}> {`${t("space.ratingsFrom")} 10`}</span>
        </div>
      </div>
    </div>
  );
};

export default ReviewStars;
